import { useEffect } from 'react';
import { books } from '../data/books';
import { COVER_SIZES, coverSrc, coverSrcSet } from '../utils/images';
const PRECONNECT_ORIGINS: {
  href: string;
  crossOrigin?: boolean;
}[] = [{
  href: 'https://fonts.googleapis.com'
}, {
  href: 'https://fonts.gstatic.com',
  crossOrigin: true
}, {
  href: 'https://images.weserv.nl'
}, {
  href: 'https://cdn.magicpatterns.com'
}, {
  href: 'https://connect.facebook.net'
}, {
  href: 'https://rutinasimple.com'
}];

/** LCP candidate: the centered cover in the hero fan. */
const HERO_IMAGE = books[2].cover;
function appendLink(attributes: Record<string, string>): HTMLLinkElement | null {
  const selector = `link[rel="${attributes.rel}"][href="${attributes.href}"]`;
  if (document.head.querySelector(selector)) return null;
  const link = document.createElement('link');
  Object.entries(attributes).forEach(([key, value]) => link.setAttribute(key, value));
  document.head.appendChild(link);
  return link;
}

/**
 * Injects network hints: preconnect for the font, image and pixel origins plus
 * a high-priority preload of the hero cover (which is never lazy-loaded). The
 * preload mirrors the <img> srcset/sizes so the browser reuses one request.
 */
export function ResourceHints() {
  useEffect(() => {
    const created: HTMLLinkElement[] = [];
    PRECONNECT_ORIGINS.forEach(origin => {
      const link = appendLink({
        rel: 'preconnect',
        href: origin.href,
        ...(origin.crossOrigin ? {
          crossorigin: 'anonymous'
        } : {})
      });
      if (link) created.push(link);
    });
    const preload = appendLink({
      rel: 'preload',
      as: 'image',
      href: coverSrc(HERO_IMAGE),
      imagesrcset: coverSrcSet(HERO_IMAGE),
      imagesizes: COVER_SIZES,
      fetchpriority: 'high'
    });
    if (preload) created.push(preload);
    return () => {
      created.forEach(link => link.remove());
    };
  }, []);
  return null;
}